import { FC } from 'react';
import { MdClose } from 'react-icons/md';
import { Styled, AppliedFilterListProps } from '.';
import { useI18n } from 'contexts/i18n';

const AppliedFilterList: FC<AppliedFilterListProps> = ({
  allFilters,
  appliedFilters,
  removeFilter,
  clearAllFilters,
  translations,
}) => {
  const getTranslatedName = (name: string) => {
    return translations?.[name] || name;
  };

  const getFilterName = (filterKey: string) => {
    const filter = allFilters?.find(filter => filter.key === filterKey);
    return filter ? getTranslatedName(filter.name) : filterKey;
  };
  const i18n = useI18n();
  return (
    <Styled.AppliedFiltersContainer>
      {appliedFilters &&
        appliedFilters.map(appliedFilter => {
          return (
            <Styled.AppliedFilterItem
              key={`${appliedFilter.filterKey}-${appliedFilter.filterValue}`}
              onClick={() =>
                removeFilter(appliedFilter.filterKey, appliedFilter.filterValue)
              }
            >
              <Styled.AppliedFilterName>
                {getFilterName(appliedFilter.filterKey)}:
                <span> {getTranslatedName(appliedFilter.filterValue)}</span>
              </Styled.AppliedFilterName>
              <MdClose />
            </Styled.AppliedFilterItem>
          );
        })}
      {appliedFilters.length > 0 && (
        <Styled.ClearAll onClick={clearAllFilters}>{i18n['Clear All']}</Styled.ClearAll>
      )}
    </Styled.AppliedFiltersContainer>
  );
};

export default AppliedFilterList;
